"use client";

import { FC } from "react";
import { useIsMobile } from "@/utils/useIsMobile";
import Button from "../button";

interface IActionButton {
  desktopTitle: string;
  mobileTitle: string;
}

const ActiveEngageButton: FC<IActionButton> = ({ desktopTitle, mobileTitle }) => {
  const isMobile = useIsMobile();

  const handleClick = () => {
    if (!window.ActivEngage) {
      console.error("ActivEngage vendor script is missing");
      return;
    }
    if (isMobile) {
      window.ActivEngage.launchSms({ data: { launchsource: "inline-chat" } });
      return;
    }
    window.ActivEngage.launchChat({ data: { launchsource: "inline-chat" } });
  };
  return <Button onClick={handleClick}>{isMobile ? mobileTitle : desktopTitle}</Button>;
};

export default ActiveEngageButton;
